import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import MessageIcons from '../../../../../enums/MessageIcons';
import MessageType from '../../../../../enums/MessageType';
import Language from '../../../../lang/language';

const useStyles = createUseStyles({
  errorIcon: {
    fill: props => ((props.isArtemisIcon && props.theme.colors?.[MessageType.ERROR]?.base)
      ? props.theme.colors[MessageType.ERROR].base : props.theme.core.messageColours[MessageType.ERROR].foreground),
    verticalAlign: 'middle',
  },
});

export default function ErrorIcon(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const altText = Language.getText('accessibility.icon.alt.error');
  
  switch (theme.core.messageIconStyles[MessageType.ERROR]) {
    case MessageIcons.ROUND:
      return (
        <svg
          className={classes.errorIcon}
          data-test="ErrorIcon__round"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          title={altText}
        >
          <path
            fill="#a82a30"
            fillRule="evenodd"
            d={'M19.886 10.4c0-5.523-4.451-10-9.943-10S0 4.877 0 10.4s4.451 10 9.943 10 '
            + '9.943-4.477 9.943-10zM9.391 13.733h1.104c.305 0 .553.25.553.556V15.4c0 .307-.248.556-.553.556H9.391c-.305 '
            + '0-.553-.25-.553-.556v-1.111c0-.307.248-.556.553-.556m0-8.889h1.104c.305 0 .553.25.553.556v5.556c0 '
            + '.306-.248.555-.553.555H9.391c-.305 0-.553-.249-.553-.555V5.4c0-.307.248-.556.553-.556'}
          />
        </svg>
      );
    case MessageIcons.DEFAULT:
    default:
      return (
        <svg
          className={classes.errorIcon}
          data-test="ErrorIcon__default"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          title={altText}
        >
          <path
            fillRule="nonzero"
            d={'M12 1l12 22H0L12 1zm1 8h-2v7h2V9zm-1 8c-.863 0-1.5.65-1.5 1.494 '
            + '0 .856.637 1.506 1.5 1.506s1.5-.65 1.5-1.506C13.5 17.65 12.863 17 12 17z'}
          />
        </svg>
      );
  }
}

ErrorIcon.propTypes = {
  isArtemisIcon: PropTypes.bool,
};
